import { render, staticRenderFns } from "./shipboard.vue?vue&type=template&id=544f1624&scoped=true&"
import script from "./shipboard.vue?vue&type=script&lang=js&"
export * from "./shipboard.vue?vue&type=script&lang=js&"
import style0 from "./shipboard.vue?vue&type=style&index=0&id=544f1624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f1624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
